import { BooleanField, Datagrid, EditButton, List, ListActions, ShowButton, SimpleList, TextField } from "react-admin";
import { useMediaQuery } from "@mui/material";
import { checkPermission } from "server/security/utils";
import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import SecuredComponent from "server/security/SecuredComponent";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";

const ListHospitality = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  return (
    <List
      title="Болници"
      exporter={false}
      actions={<ListActions hasCreate={checkPermission(getPermissions(), permissions.canManageHospitalities)} />}
    >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow fields={[{ label: "Име на български", value: record?.nameBg }]} />
          )}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Име на английски", value: record?.nameEn }]} />
              <MobileListRow
                fields={[
                  {
                    label: "Видима в КСК",
                    value: record?.visibleInCandidateCampaigns ? "Да" : "Не",
                  },
                ]}
              />
            </div>
          )}
          tertiaryText={() => (
            <>
              <SecuredComponent permission={permissions.canManageHospitalities}>
                <EditButton label="" />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canPreviewHospitalities}>
                <ShowButton label="" />
              </SecuredComponent>
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="nameBg"
            label="Име на български"
            sortable={false}
          />
          <TextField
            source="nameEn"
            label="Име на английски"
            sortable={false}
          />
          <BooleanField
            source="visibleInCandidateCampaigns"
            label="Видима в КСК"
            sortable={false}
          />
          <SecuredComponent permission={permissions.canManageHospitalities}>
            <EditButton />
          </SecuredComponent>
          <SecuredComponent permission={permissions.canPreviewHospitalities}>
            <ShowButton />
          </SecuredComponent>
        </Datagrid>
      )}
    </List>
  );
};
export default ListHospitality;
